import React from 'react';
import * as S from './Ratings.styles';

type Ratingsprops = {
  ratingCount?: string;
  color?: string;
};

const Ratings = ({ratingCount, color}: Ratingsprops) => (
  <S.BusRating className={color}>
    <S.RatingNumber>{ratingCount}</S.RatingNumber>
    <S.RatingNumber>/5</S.RatingNumber>
  </S.BusRating>
);

export default Ratings;
